import stepper from '../../../assets/images/components/stepper.png';
import { FlexBox } from '../LBox/LBox';
import React from 'react';
import { Tmd14, Trg12, Icon } from 'oui';

import styled from 'styled-components';

const BoxWrap = styled.div`
  display: flex;
  align-items: center;

  & + & {
    margin-top: 20px;
  }
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 8px 10px;
  margin-right: 10px;

  > div {
    margin-left: 10px;
  }
`;

interface IStepBoxProp {
  label: string;
  text: string;
  isIcon: boolean;
}

interface IStepBox {
  list: IStepBoxProp[];
  onClick: () => void;
}

export const StepBox = ({ list, onClick }: IStepBox) => {
  return (
    <FlexBox alignItems={'center'} padding={'20px'}>
      <img
        src={stepper}
        alt={'stepper'}
        style={{ height: 231, marginRight: 20 }}
      />

      <div>
        {list.map((item) => {
          return (
            <BoxWrap key={item.label}>
              <Box>
                <Tmd14 text={item.label} color={'#696969'} />
                {item.isIcon && (
                  <div onClick={onClick}>
                    <Icon name={'InfoOutlined'} size={'sm'} color={'primary'} />
                  </div>
                )}
              </Box>
              <Trg12 text={item.text ?? ''} />
            </BoxWrap>
          );
        })}
      </div>
    </FlexBox>
  );
};
